const sharedLifetimeFeatures = [
  'School ERP – Web Version + Modules',
  'WhatsApp / SMS Integration',
  'SMS Integration',
  'Online Payment',
  'Students / Parents Web Login + Mobile App (Android)',
  'Push Notifications',
  'Students / Parents Web Login + Mobile App (iOS)',
  'Teacher / Admin App (iOS)',
  'Library Module',
  'Biometric / RFID / Face Recognition',
  'Geofencing Employee Attendance',
  'QR Code-based Student Attendance',
];

const sharedCustomFeatures = [
  'School ERP – Web Version + Modules',
  'WhatsApp + SMS Integration',
  'Online Payment Gateway',
  'Teacher + Admin Android App',
  'Push Notifications',
  'Biometric / RFID Integration',
  'Library Module',
  'Parent Mobile App',
  'AI-based Face Recognition Attendance',
  'Geofencing Employee Attendance',
  'QR Code-based Student Attendance',
];

export const lifetimePlans = [
  {
    id: 'starter',
    code: 'PLAN A',
    name: 'Starter',
    amount: 500000,
    blurb: 'Ideal for schools up to 350 students needing essential ERP tools.',
    meta: 'Up to 350 students · Annually renewable support',
    features: sharedLifetimeFeatures,
    cta: 'Buy Now',
    variant: 'outline',
  },
  {
    id: 'standard',
    code: 'PLAN B',
    name: 'Standard',
    amount: 750000,
    blurb: 'Suitable for growing schools needing core modules at great value.',
    meta: 'Growing schools · Annually renewable support',
    features: sharedLifetimeFeatures,
    cta: 'Buy Now',
    variant: 'outline',
  },
  {
    id: 'premium',
    code: 'PLAN C',
    name: 'Premium',
    amount: 1250000,
    blurb: 'Best for medium-scale schools needing robust management.',
    meta: 'Medium-scale campuses · Annually renewable support',
    features: sharedLifetimeFeatures,
    cta: 'Buy Now',
    variant: 'filled',
    popular: true,
  },
];

export const customPlans = [
  {
    id: 'custom-premium',
    code: 'PLAN C',
    name: 'Premium',
    badge: 'Premium',
    amount: 1500000,
    blurb: 'A modular ERP for daily school operations.',
    meta: 'Custom modules · Dedicated onboarding',
    features: sharedCustomFeatures,
    cta: 'Buy Now',
    variant: 'custom',
  },
  {
    id: 'platinum',
    code: 'PLAN D',
    name: 'Platinum',
    badge: 'Platinum',
    amount: 3000000,
    blurb: 'Advanced automation for growing institutions.',
    meta: 'Multi-team operations · Priority support',
    features: sharedCustomFeatures,
    cta: 'Buy Now',
    variant: 'custom',
  },
  {
    id: 'enterprise-ai',
    code: 'PLAN AI',
    name: 'Enterprise AI',
    badge: 'Enterprise AI',
    amount: 9000000,
    blurb: 'Complete AI-powered digital campus solution.',
    meta: 'AI analytics · Enterprise integration',
    features: sharedCustomFeatures,
    cta: 'Buy Now',
    variant: 'custom',
  },
];

export const customPlanIncludes =
  'All custom plans include: custom marksheet, bonafide certificate, report card, transfer certificate, character certificate, ID card, admit card, and more.';

export const allPlans = [...lifetimePlans, ...customPlans];

export function getPlanById(planId) {
  return allPlans.find((plan) => plan.id === planId) || null;
}

export function formatInr(amount) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
}
